// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lq-3";
export var downloadButton = "_lq-4";
export var fileContainer = "_lq-9 _lq-7";
export var fileContainerBase = "_lq-7";
export var fileContainerFixedHeight = "_lq-8 _lq-7";
export var fileInfo = "_lq-5";
export var fileInfoWidthRestricted = "_lq-6";
export var fileType = "_lq-1";
export var fileTypeName = "_lq-2";
export var image = "_lq-0";
export var link = "_lq-b";
export var overflowEllipsis = "_lq-a";